import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import Page from 'components/layouts/page/Page';
import CircularProgress from 'components/shared/CircularProgress';
import useWorkflow from 'hooks/useWorkflow';
import { Body, BodySmall, H2 } from 'styles/typography';

import ReferralForm from './ReferralForm';

export default function EditInboundReferralPage() {
  const { workflowId } = useParams<{ workflowId: string }>();
  const { workflow, isLoading, isError } = useWorkflow(workflowId);

  if (isLoading)
    return (
      <Centered>
        <CircularProgress />
      </Centered>
    );
  if (isError || !workflow)
    return (
      <Centered>
        <Body>We couldn’t load this referral.</Body>
      </Centered>
    );

  return (
    <Page>
      <Page.Header>
        <HeaderInner>
          <H2>Edit referral</H2>
          <BodySmall>Update the packet or the patient’s details.</BodySmall>
        </HeaderInner>
      </Page.Header>
      <Page.Content>
        <ReferralForm workflow={workflow} />
      </Page.Content>
    </Page>
  );
}

const Centered = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

const HeaderInner = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
